<template>
  <div class="ProjectImageMobile" :class="[{twoPhones:twoPhones}, {center:center}]">

    <div class="phone">
      <div class="phoneWrapper">
        <div class="scrollIcon" v-if="canScroll1"><svg><use xlink:href="#mouseScroll"></use></svg></div>
        <div class="phoneTab" v-if="showTab">
          <img src="/assets/ui/iphone-tab.png" srcset="/assets/ui/iphone-tab.png 192w, /assets/ui/iphone-tab@2x.png 384w" sizes="191px">
        </div>
        <div class="phoneViewport" v-if="isVideo1">
          <div class="scroller">
            <lazy-component tag="div">
              <video autoplay loop playsinline muted controls>
                <source :src="srcImage1 + '.mp4'" type="video/mp4">
                <source :src="srcImage1 + '.webm'" type="video/webm">
              </video>
            </lazy-component>
            <transition name="vFade">
              <div class="loading movie"><svg><use xlink:href="#loading"></use></svg></div>
            </transition>
          </div>
        </div>
        <div class="phoneViewport" :class="{canScroll:canScroll1}" v-else>
          <div class="scroller">
            <img v-lazy="srcImage1" :data-srcset="srcSet1" sizes="(max-width: 380px) 100vw, 330px" class="main">
            <transition name="vFade">
              <div class="loading" v-if="!mainLoaded1"><svg><use xlink:href="#loading"></use></svg></div>
            </transition>
          </div>
        </div>
        <img src="/assets/ui/iphone-body.png" srcset="/assets/ui/iphone-body.png 380w, /assets/ui/iphone-body@2x.png 760w" sizes="(max-width: 380px) 100vw, 380px" class="phoneBody">
  
      </div>
  
      <div class="caption" v-if="caption1 != null">
        <div class="text">{{ caption1 }}</div>
      </div>
    </div>

    <div class="phone" v-if="twoPhones">
      <div class="phoneWrapper">
        <div class="scrollIcon" v-if="canScroll2"><svg><use xlink:href="#mouseScroll"></use></svg></div>
        <div class="phoneTab" v-if="showTab">
          <img src="/assets/ui/iphone-tab.png" srcset="/assets/ui/iphone-tab.png 192w, /assets/ui/iphone-tab@2x.png 384w" sizes="191px">
        </div>
        <div class="phoneViewport" v-if="isVideo2">
          <div class="scroller">
            <lazy-component tag="div">
              <video autoplay loop playsinline muted controls>
                <source :src="srcImage2 + '.mp4'" type="video/mp4">
                <source :src="srcImage2 + '.webm'" type="video/webm">
              </video>
            </lazy-component>
            <transition name="vFade">
              <div class="loading movie"><svg><use xlink:href="#loading"></use></svg></div>
            </transition>
          </div>
        </div>
        <div class="phoneViewport" :class="{canScroll:canScroll2}" v-else>
          <div class="scroller">
            <img v-lazy="srcImage2" :data-srcset="srcSet2" sizes="(max-width: 380px) 100vw, 330px" class="main">
            <transition name="vFade">
              <div class="loading" v-if="!mainLoaded2"><svg><use xlink:href="#loading"></use></svg></div>
            </transition>
          </div>
        </div>
        <img src="/assets/ui/iphone-body.png" srcset="/assets/ui/iphone-body.png 380w, /assets/ui/iphone-body@2x.png 760w" sizes="(max-width: 380px) 100vw, 380px" class="phoneBody">
      </div>
      <div class="caption" v-if="caption2 != null">
        <div class="text">{{ caption2 }}</div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'ProjectImageMobile',
  props: {
    srcImage1: {
      type: String,
      default: null
    },
    largeImage1: {
      type: String,
      default: null
    },
    isVideo1: {
      type: Boolean,
      default: false
    },
    srcImage2: {
      type: String,
      default: null
    },
    largeImage2: {
      type: String,
      default: null
    },
    isVideo2: {
      type: Boolean,
      default: false
    },
    caption1: {
      type: String,
      default: null
    },
    caption2: {
      type: String,
      default: null
    },
    canScroll1: {
      type: Boolean,
      default: false
    },
    canScroll2: {
      type: Boolean,
      default: false
    },
    center: { // center a single phone mock
      type: Boolean,
      default: false
    },
    showTab: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mainLoaded1: false,
      mainLoaded2: false
    }
  },
  mounted() {
    // globally register lazyload listner to fire
    // when images are loaded
    this.$Lazyload.$on('loaded', (el) => {
      this.handleMobileLoading(el)
    })
  },
  destroyed () {
    this.$Lazyload.$off('loaded')
  },
  methods: {
    // turn loading animaitons off/on depending on whether
    // the image has loaded
    handleMobileLoading(el) {
      let currentSrc = el.src
      if (currentSrc == this.srcImage1 || currentSrc == this.largeImage1) {
        this.mainLoaded1 = true
      }
      if (currentSrc == this.srcImage2 || currentSrc == this.largeImage2) {
        this.mainLoaded2 = true
      }
    }
  },
  computed: {
    twoPhones() {
      if (this.srcImage2 != null) {
        return true
      } else {
        return false
      }
    },
    srcSet1() {
      return this.srcImage1 + ' 330w, ' + this.largeImage1 + ' 660w'
    },
    srcSet2() {
      return this.srcImage2 + ' 330w, ' + this.largeImage2 + ' 660w'
    }
  }
}
</script>

<style lang="scss" scoped>
.ProjectImageMobile {
  width: 100%;
  margin: 70px auto;
  color: #000;
  text-align: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & .phone {
    width: 380px;

    & > .phoneWrapper {
      width: 380px;
      height: 764px;
      position: relative;

      & .scrollIcon {
        position: absolute;
        top: 60px;
        top: 50%;
        transform: translateY(-50%);
        left: -40px;
        width: 20px;
        height: 53px;

        & svg {
          width: 100%;
          height: 100%;
          fill: #aaa;
        }
      }

      & .phoneBody {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
      }
      & .phoneTab {
        width: 191px;
        height: 27px;
        position: absolute;
        top: 23px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;

        & img {
          width: 100%;
          height: 100%;
        }
      }

      & .phoneViewport {
        width: 330px;
        height: 715px;
        border-radius: 33px;
        position: absolute;
        z-index: 5;
        top: 23px;
        left: 50%;
        transform: translateX(-50%);
        overflow: hidden;

        & .scroller {
          overflow: hidden;

          & > img {
            display: block;
            width: 100%;
            height: auto;
            position: relative;
            z-index: 5;
            transition: opacity 2000ms;

            &[lazy=loading] {
              opacity: 0;
            }
            &[lazy=loaded] {
              opacity: 1;
            }
          }

          & video {
            width: 100%;
            position: relative;
            z-index: 5;
          }
    
          & .loading {
            position: absolute;
            width: 100px;
            height: 100px;
            left: 50%;
            top: 45%;
            transform: translate(-50%,-50%);
    
            & svg {
              width: 50px;
              height: 50px;
              position: absolute;
              top: 0;
              left: 50%;
              transform: translateX(-50%);
            }
    
            &::after {
              content: 'Loading';
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              bottom: 0;
              color: $greyDark;
              text-transform: uppercase;
              font-size: 12px;
            }
            // movie version
            &.movie {
              &::after {
                content: 'Loading Movie';
                line-height: 15px;
              }
            }
          }
        }

        // scrollable
        &.canScroll {
          & .scroller {
            width: calc(100% + 20px);
            height: 100%;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;

            & img {
              width: 330px;
            }
          }
        }
      }
    }

    & .caption {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid $greyMed;
      margin: 25px 0 0 0;
      padding: 10px 0 0 0;
      width: 100%;

      & .text {
        font-size: 13px;
        @include fontItalic;
        line-height: 18px;
        color: $greyDark;
        text-align: left;
      }
    }
  }

  // two phones
  &.twoPhones {
    // TODO: not needed?
  }

  // center
  &.center {
    justify-content: space-around;
  }
  // break at single phone
  @media screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: center;

    & .phone {
      margin: 0 0 60px 0;
    }
  }
  // break at phone width; strip UI away
  @media screen and (max-width: 380px) {
    & .phone {
      width: 100%;

      & > .phoneWrapper {
        width: 100%;
        height: auto;

        & .scrollIcon {
          display: none;
        }

        & .phoneBody {
          display: none;
        }
        & .phoneTab {
          display: none;
        }

        & .phoneViewport {
          width: 100%;
          height: auto;
          border-radius: 0;
          position: relative;
          top: auto;
          left: auto;
          transform: none;
          overflow: visible;

          & .scroller {
            overflow: visible;

            & > img {
            }
          }

          // scrollable
          &.canScroll {
            & .scroller {
              width: 100%;
              overflow-y: visible;
              -webkit-overflow-scrolling: initial;

              & img {
                width: 100%;
              }
            }
          }
        }
      }

      & .caption {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid $greyMed;
        margin: 25px 0 0 0;
        padding: 10px 0 0 0;
        width: 100%;

        & .text {
          font-size: 13px;
          @include fontItalic;
          line-height: 18px;
          color: $greyDark;
        }
      }
    }
  }
}

</style>
